import { UserRole } from '../models/UserData';

export type RoleTier = 'GROUP' | 'TEAM' | 'ORGANIZATION';
export type RoleType = 'ADMIN' | 'REPORTING_ADMIN' | 'REVENUE_ADMIN';

export const buildRoleKey = (tier: RoleTier, type: RoleType, id: number | string): string =>
  `${tier}_${type}_${id}`;

export const hasRole = (
  roles: UserRole[] | undefined,
  tier: RoleTier,
  type: RoleType,
  id: number | string | null | undefined,
): boolean => {
  if (id === null || id === undefined) return false;
  const key = buildRoleKey(tier, type, id);
  return roles?.some(role => role.role === key) ?? false;
};
